import styled, {css} from 'styled-components';

import BaseInfoOutlinedIcon from '@edna/icons/infoOutlined.svg';

import BaseDropdown, {Head as BaseHead, Overlay} from '../Dropdown';
import {mixins} from '../styles';
import {TSize} from '../types';

type TDropdownProps = {
  hasMarginLeft?: boolean;
  hasMarginRight?: boolean;
};

export const Dropdown = styled(BaseDropdown)<TDropdownProps>`
  display: inline-block;
  ${({theme: {spacing}, hasMarginLeft, hasMarginRight}) => css`
    margin: 0 ${hasMarginRight ? spacing.s1 : 0} 0 ${hasMarginLeft ? spacing.s1 : 0};
  `}
`;

export type TInfoOutlinedIconProps = TTheme & {
  size: TSize;
};

const getIconStyle = ({theme: {branding}, size}: TInfoOutlinedIconProps) => css`
  ${mixins.round(size === 'L' ? '24px' : '20px')}
  color: ${branding.content.secondary};

  &:hover {
    color: ${branding.content.primary};
  }
`;

export const InfoOutlinedIcon = styled(BaseInfoOutlinedIcon)<TInfoOutlinedIconProps>`
  display: inline-block;
  ${getIconStyle}
`;

const getInfoDropdownOverlayStyle = ({theme}: TTheme) => css`
  z-index: ${theme.zIndex.infoDropdown};
  border-radius: ${theme.borderRadius.br1};
  color: ${theme.palette.white};
  box-shadow: ${theme.boxShadow.dropdown};
  > a {
    color: ${theme.palette.white};
  }
`;

export const InfoDropdownOverlay = styled(Overlay)`
  width: 300px;
  min-width: 50px;
  white-space: pre-line;
  ${getInfoDropdownOverlayStyle}
`;

export const InfoDropdownContent = styled.div`
  padding: ${({theme}) => `${theme.spacing.s3} ${theme.spacing.s4}`};
`;

export const InfoDropdownHead = styled(BaseHead)`
  display: flex;
  cursor: help;
`;
